import styled, { css } from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos RegisterModal
Description : Se definen los estilos de los elementos del resto del formulario
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen estilos y elementos del formulario
================================================================================ */

export const FormGroup = styled.div`
    width: 95%;
    height: 30px;
    /* margin: 50px; */
    margin-left: 20px;
    /* margin-right: 5px; */
    margin-bottom: 50px;
    margin-top: -5px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    @media screen and (max-width: 961px){
        width: 90%;
        justify-content: 'center'
    }
`;

export const Form = styled.form`
    width: 80%;
    @media screen and (max-width: 961px){
        width: 90%;
        justify-content: 'center'
    }
`;

export const Forms = styled.div`
    width: 90%;
    @media screen and (max-width: 961px){
        /* width: 90%; */
        justify-content: 'center'
    }
`

export const Div = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 961px){
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`

export const Button = styled.button`
    background-color: #3498DB;
    margin-bottom: 10px;
`;

export const Label = styled.label`
	color: #3498DB;
    display: flex;
    justify-content: flex-start;
    margin-left: 0px;
    /* margin-top: -5px; */
    font-size: 14px;
`;

export const Input = styled.input`
	padding: 0.5em;
	width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
`;

export const Image = styled.img`
    width: 40%;
    margin-top: 0.5em;
`;

export const H2 = styled.h2`
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    z-index: 1;
    &:before {
        border-top: 1px solid #1061a2;
        content: "";
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        bottom: 0;
        width: 75%;
        z-index: -1;
    };
`;

export const Span = styled.span`
    background: #fff;
    padding: 0;
`;

export const Select2 = styled.select`
    padding: 0.5em;
    width:100%;
    margin-top: -3px;
    margin-bottom: -3px;
    option {
        display: flex;
        white-space: pre;
        min-height: 20px;
        padding: 0px 2px 1px;
      }
`;